import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import {Link} from "react-router-dom";
import "./css/Footer.css";

class Footer extends React.Component {
    render ()
    {
        return (
            <footer className="footer bg-dark text-white">
  <div className="container">
    <div className="row">
      <div className="col-12 col-md-4 col-lg-4 text-center">
        <h5>Acerca de Nosotros</h5>
        <div className="text-center"><strong>AJE, SL</strong></div>
        <p></p>
        <div className="text-center">Innovando soluciones</div>
        <div className="text-center">Huelva, Andalucía.</div>
      </div>

      <div className="col-12 col-md-4 col-lg-4 text-center">
        <h5></h5>
        <div className="text-center"></div>
        <p></p>
        <div className="d-flex justify-content-center text-center">© 2025 AJE, SL. Todos los derechos reservados.</div>
        <p></p>
        <div className="justify-content-center text-center"> <Link to="/politica_cookies" className='btn btn-light contact-button'>Política de cookies</Link></div>
      
      </div>

      <div className="col-12 col-md-4 col-lg-4 text-center">
        <h5>Contacto</h5>
        <div className="text-center"> Email: web@ajesl.es </div>
        <p></p>
        <div className="justify-content-center text-center"> <Link to="/contacto" className='btn btn-light contact-button'>Formulario de Contacto</Link></div>
      </div>
    </div>
  </div>
  </footer> 
        );
    }
}

export default Footer;